var product_count;
function product_counter(){
    var product_box = document.getElementsByClassName('product-box');
    product_count = product_box.length;
    var active_pdps = document.querySelector('.collection_active_pdps');
    if(active_pdps){active_pdps.textContent = product_count;}
}

document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener('load', function() {
    setTimeout(function() {
        product_counter();
    }, 1000);
  });
});

document.addEventListener('click', function(event) {
    if (event.target.matches('#load-more-btn a.btn')) {
      var cal_pdp = setInterval(function() {
        var current_c = document.getElementsByClassName('product-box');
        var current_count = current_c.length;
        if(current_count > product_count){
          product_counter();
          clearInterval(cal_pdp);
        }
      },500);
    }
});

$(document).on('change','#collection-filters__sort',function(){
  var cur_link = window.location.href;
  var sort_pdp = setInterval(function() {
      if(cur_link != window.location.href){  
        clearInterval(sort_pdp);
        setTimeout(function(){product_counter();},1500);
      }
    },500);
});

$(document).on('change','input.range-slider',function(){
    setTimeout(function(){product_counter();},1500);
});

$(document).on('click','.custom_check',function(){
  var cur_link = window.location.href;
  var sort_pdp = setInterval(function() {
      if(cur_link != window.location.href){  
        clearInterval(sort_pdp);
        setTimeout(function(){product_counter();},1500);
      }
    },500);
});

document.addEventListener('click', function(event) {
    if (event.target.matches('.js-facet-remove')) {
      setTimeout(function(){product_counter();},1500);
    }
});


// $(document).on('change','#collection-filters__sort',function(){
//   setTimeout(function(){
//     product_counter();
//   },2000);
// });


$(document).ready(function(){

  var offer_swiper = new Swiper(".offer_box_grid", {
      slidesPerView: 2,
      spaceBetween: 8,
      breakpoints: { 
        320: { slidesPerView: 2, spaceBetween: 8 },
        768: { slidesPerView: 2, spaceBetween: 8 },
        992: { slidesPerView: 2 },
        1200: { slidesPerView: 2 }
    },
  });
  
  $('.offer_box_btn').click(function(){
    var $this = $(this); // Save $(this) in a variable
    $this.closest('.offer_box_item').find('input').select();
    if ( document.execCommand( 'copy' ) ) {
      $this.addClass('copied');
      var temp = setInterval( function(){
        $this.removeClass('copied'); // Use $this instead of $(this)
        clearInterval(temp);
      }, 600 ); 
    }
  });  

   $(document).on('click', '.select-items-overlay', function() {
      $('.collection-filters__field .select').removeClass('active');
    });

  $(document).on('click', '.accordion-toggle', function() {
    $('.panel-group .panel').removeClass('active-accordion');
    if ($(this).hasClass('collapsed')) {
      $(this).closest('.panel').removeClass('active-accordion');
    } else {
      $(this).closest('.panel').addClass('active-accordion');
    }
  });

  $(document).on('click','.search-results-wrapper button[type="submit"]',function(e){
    e.preventDefault();
    $(this).closest('.search-popup-wrap').find('form.minisearch').submit();
  });

  $('input[data-search-input]').on('input',function(){
      if($(this).val() != ""){
        $('.search_input_clear').css('display','flex');
      }else{
        $('.search_input_clear').hide();
      }      
    });
  
  $('.search_input_clear').click(function(){
    $(this).hide();
    $('input[data-search-input]').val('');
    setTimeout(function(){
      $('input[data-search-input]').trigger('change');
    },500);
  });

  // $('.tag-nav-item').click(function(){
  //   var collection_handle = $(this).attr('subcollection_handle');
  //   $('.tag-nav-item').removeClass('active');
  //   $('a.tag-nav-item[subcollection_handle="'+ collection_handle +'"]').addClass('active');
  //   console.log(collection_handle)
  // });

  
  
});





// Countdown Timer Product Page 
document.addEventListener("DOMContentLoaded", function() {

  let el = document.querySelector(".countdown-value");
  if (!el) return;

  let timeParts = el.textContent.trim().split(":");

  let hours = parseInt(timeParts[0]) || 0;
  let minutes = parseInt(timeParts[1]) || 0;
  let seconds = parseInt(timeParts[2]) || 0;

  let totalSeconds = hours * 3600 + minutes * 60 + seconds;

  function updateTimer() {
    if (totalSeconds <= 0) return;

    totalSeconds--;

    let h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    let m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    let s = String(totalSeconds % 60).padStart(2, "0");

    el.textContent = `${h}:${m}:${s}`;
  }

  setInterval(updateTimer, 1000);

});
 






(function () {
  function updateImages(variantId) {
    const wrap = document.getElementById('variant-desc-image-wrap');
    if (!wrap) return;

    const images = window.variantDescriptionImages?.[variantId];
    wrap.innerHTML = '';

    if (images && images.length > 0) {
      images.forEach(function (src) {
        const img = document.createElement('img');
        img.src = src;
        img.loading = 'lazy';
        wrap.appendChild(img);
      });
    }
  }

  // Preload all variant images on page load
  function preloadAll() {
    Object.values(window.variantDescriptionImages || {}).forEach(function (images) {
      images.forEach(function (src) {
        const img = new Image();
        img.src = src;
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-single-option]')) return;

    // Get variant ID directly from the form hidden input
    const form = e.target.closest('form') || document.querySelector('form[id^="product-form-"]');
    const variantInput = form?.querySelector('input[name="id"]');

    // Read immediately or fallback to timeout
    if (variantInput?.value) {
      updateImages(variantInput.value);
    } else {
      setTimeout(function () {
        const id = document.querySelector('input[name="id"]')?.value;
        if (id) updateImages(id);
      }, 50);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    preloadAll(); // preload all images in background
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput?.value) updateImages(variantInput.value);
  });
})();